import { size } from "lodash";
import { formatDateForDisplay } from "../../Utils/UtilityFunctions";
import StatusBadge from "../StatusBadge";

export const PaymentHistorycoloumn = () => {
  const PaymentHistorycoloumns = [
    {
      accessorKey: "orderID",
      header: "Order ID",
    },
    // {
    //     accessorKey: "paymentCreatedAt",
    //     header: "Payment Created At",
    //     Cell: ({ cell }) => formatDateForDisplay(cell.getValue(), "hh:mm A"),

    // },
    {
      accessorKey: "paymentCompletedAt",
      header: "Payment Completed At",
      Cell: ({ cell }) => {
        const value = cell.getValue();
        // Show '-' if the date is exactly '0001-01-01'
        if (value && value.startsWith("0001-01-01")) {
          return "-";
        }
        return value ? formatDateForDisplay(value, "hh:mm A") : "-";
      },
    },
   {
  accessorKey: "amount",
  header: "Amount",
  Cell: ({ cell, row }) => {
    const amount = cell.getValue() / 100; // assuming paise to rupees
    const currency = row.original.currency || "INR";

    return new Intl.NumberFormat("en-IN", {
      style: "currency",
      currency: currency,
    }).format(amount);
  },
},
    {
      accessorKey: "paymentStatus",
      header: "Payment Status",
      Cell: ({ cell }) => {
        let statusValue = cell.getValue();
        if (statusValue === "Triggered") {
          statusValue = "Pending";
        }
        return <StatusBadge value={statusValue} />;
      },
    },
  ];
  return PaymentHistorycoloumns;
};
